var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import { Star } from './Star';
import getOffsetLeft from './getOffsetLeft';
import { defaultProps } from './default';
import { UlTag } from '../../Utils/AtomicTag';
var Rate = /** @class */ (function (_super) {
    __extends(Rate, _super);
    function Rate(props) {
        var _this = _super.call(this, props) || this;
        _this.onHover = function (event, index) {
            var onHoverChange = _this.props.onHoverChange;
            var hoverValue = _this.getStarValue(index, event.pageX);
            var cleanedValue = _this.state.cleanedValue;
            if (hoverValue !== cleanedValue) {
                _this.setState({
                    hoverValue: hoverValue,
                    cleanedValue: null,
                });
            }
            onHoverChange(hoverValue);
        };
        _this.onMouseLeave = function () {
            var onHoverChange = _this.props.onHoverChange;
            _this.setState({
                hoverValue: undefined,
                cleanedValue: null,
            });
            onHoverChange(undefined);
        };
        _this.onClick = function (event, index) {
            var allowClear = _this.props.allowClear;
            var value = _this.state.value;
            var newValue = _this.getStarValue(index, event.pageX);
            var isReset = false;
            if (allowClear) {
                isReset = newValue === value;
            }
            _this.onMouseLeave();
            _this.changeValue(isReset ? 0 : newValue);
            _this.setState({
                cleanedValue: isReset ? newValue : null,
            });
        };
        _this.onFocus = function () {
            var onFocus = _this.props.onFocus;
            _this.setState({
                focused: true,
            });
            onFocus();
        };
        _this.onBlur = function () {
            var onBlur = _this.props.onBlur;
            _this.setState({
                focused: false,
            });
            onBlur();
        };
        _this.saveRef = function (index) { return function (node) {
            _this.stars[index] = node;
        }; };
        _this.renderList = function () {
            var _a = _this.props, count = _a.count, allowHalf = _a.allowHalf, disabled = _a.disabled, readonly = _a.readonly, character = _a.character, characterRender = _a.characterRender, type = _a.type, checkedIcon = _a.checkedIcon, uncheckedIcon = _a.uncheckedIcon;
            var _b = _this.state, value = _b.value, hoverValue = _b.hoverValue, focused = _b.focused;
            var starDisabled = disabled || readonly;
            var stars = [];
            for (var index = 0; index < count; index++) {
                stars.push(React.createElement(Star, { ref: _this.saveRef(index), index: index, count: count, disabled: starDisabled, allowHalf: allowHalf, value: hoverValue === undefined ? value : hoverValue, onClick: _this.onClick, onHover: _this.onHover, key: index, character: character, characterRender: characterRender, focused: focused, checkedIcon: checkedIcon, uncheckedIcon: uncheckedIcon, type: type }));
            }
            return stars;
        };
        _this.render = function () {
            var _a = _this.props, disabled = _a.disabled, tabIndex = _a.tabIndex, value = _a.value, defaultValue = _a.defaultValue, count = _a.count, allowClear = _a.allowClear, allowHalf = _a.allowHalf, onChange = _a.onChange, onBeforeChange = _a.onBeforeChange, character = _a.character, onHoverChange = _a.onHoverChange, type = _a.type, checkedIcon = _a.checkedIcon, uncheckedIcon = _a.uncheckedIcon, onBlur = _a.onBlur, onFocus = _a.onFocus, characterRender = _a.characterRender, autoFocus = _a.autoFocus, readonly = _a.readonly, rest = __rest(_a, ["disabled", "tabIndex", "value", "defaultValue", "count", "allowClear", "allowHalf", "onChange", "onBeforeChange", "character", "onHoverChange", "type", "checkedIcon", "uncheckedIcon", "onBlur", "onFocus", "characterRender", "autoFocus", "readonly"]);
            var rateDisabled = disabled || readonly;
            var disabledClass = rateDisabled ? "disabled" : 'cursor-pointer';
            var stars = _this.renderList();
            var ulCls = ['inline-block', 'align-top'];
            return (React.createElement(UlTag, __assign({ name: Rate.NAME, atomics: ulCls, className: classNames("rate", disabledClass), onMouseLeave: rateDisabled ? undefined : _this.onMouseLeave, tabIndex: rateDisabled ? -1 : tabIndex, onFocus: rateDisabled ? undefined : _this.onFocus, onBlur: rateDisabled ? undefined : _this.onBlur, role: "radiogroup" }, rest), stars));
        };
        var value = props.value;
        if (value === undefined) {
            value = Number(props.defaultValue);
        }
        _this.stars = {};
        _this.state = {
            value: value,
            focused: false,
            cleanedValue: null,
        };
        return _this;
    }
    Rate.prototype.componentWillReceiveProps = function (nextProps) {
        var value = nextProps.value;
        if (value !== undefined) {
            this.setState({
                value: Number(value),
            });
        }
    };
    Rate.prototype.componentDidMount = function () {
        var _a = this.props, autoFocus = _a.autoFocus, disabled = _a.disabled, readonly = _a.readonly;
        if (autoFocus && !disabled && !readonly) {
            this.onFocus();
        }
    };
    Rate.prototype.getStarDOM = function (index) {
        return ReactDOM.findDOMNode(this.stars[index]);
    };
    Rate.prototype.getStarValue = function (index, x) {
        var allowHalf = this.props.allowHalf;
        var value = index + 1;
        if (allowHalf) {
            var starEle = this.getStarDOM(index);
            if (starEle) {
                var leftDis = getOffsetLeft(starEle);
                var width = starEle.clientWidth;
                if (x - leftDis < width / 2) {
                    value -= 0.5;
                }
            }
        }
        return value;
    };
    Rate.prototype.changeValue = function (value) {
        var _a = this.props, onChange = _a.onChange, onBeforeChange = _a.onBeforeChange;
        if (!('value' in this.props)) {
            this.setState({
                value: value,
            });
        }
        if (onBeforeChange()) {
            onChange(value);
        }
    };
    Rate.defaultProps = defaultProps;
    Rate.NAME = 'rate';
    Rate.displayName = 'Rate';
    return Rate;
}(PureComponent));
export { Rate };
